import { render } from "./index.vue?vue&type=template&id=5366c746&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=5366c746&scoped=true&lang=css"

import exportComponent from "D:\\nextinnoivation-home\\yecheonmuseum-web-ar-release-ycg-1.0.0\\frontend\\user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5366c746"]])

export default __exports__